// Simple API client for Shops endpoints
// Backend controller: /api/shops
import {apiUrl} from '../config/api'

export async function listShops() {
  const res = await fetch(apiUrl('/api/shops?hidden=true'), {
    headers: { 'Accept': 'application/json' },
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function createShop(payload) {
  const res = await fetch(apiUrl('/api/shops'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function updateShop(id, payload) {
  const res = await fetch(apiUrl(`/api/shops/${id}`), {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function deleteShop(id) {
  const res = await fetch(apiUrl(`/api/shops/${id}`), {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return true;
}
